import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import { appContext } from '../../util/decorators';
import isUnsupportedBrowser from '../../util/isUnsupportedBrowser';
import sentryLog from '../../universalSentryLog';

const supportedBrowsersText = [{
  name: 'Chrome',
  text: 'By Google',
  link: 'https://www.google.com/chrome/',
}, {
  name: 'Safari',
  text: 'By Apple',
  link: 'http://www.apple.com/safari/',
}, {
  name: 'Firefox',
  text: 'By Mozilla',
  link: 'https://www.mozilla.org/firefox',
}, {
  name: 'Edge',
  text: 'By Microsoft',
  link: 'https://www.microsoft.com/microsoft-edge',
}];

@appContext
export default class UnsupportedBrowserNotification extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isUnsupportedBrowser: false,
    };
  }

  checkBrowserSupport() {
    const unsupported = isUnsupportedBrowser();

    if (unsupported) {
      sentryLog('Showing unsupported browser message to user');
    }

    this.setState({
      isUnsupportedBrowser: unsupported,
    });
  }

  componentDidMount() {
    this.checkBrowserSupport();
  }

  render() {
    const t = this.context.app.t;

    return (
      <div className={cx({
        'enabled': this.state.isUnsupportedBrowser,
        'unsupported-browser': true,
      })}>

        <button className="message-close" onClick={() => this.setState({ isUnsupportedBrowser: false })}>
          <i className="icon-x-large"></i>
          <span className="structural">{t('UnsupportedBrowser.close')}</span>
        </button>

        <div className="message-area">
          <h1>{t('UnsupportedBrowser.heading')}</h1>
          <p>{t('UnsupportedBrowser.body')}</p>
          <p><b>{t('UnsupportedBrowser.meta')}</b></p>

          <div className="supported-browsers">
            {
              _.map(supportedBrowsersText, browser => {
                const logo = require(`../../../assets/browser-icons/${browser.name}.png`);
                return (
                  <div className="browser" key={browser.name}>
                    <img className="icon" src={logo} />
                    <div className="browser-name">
                      <a href={browser.link} target="_blank"><p><b>{browser.name}</b></p></a>
                      <p className="browser-by">{browser.text}</p>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/UnsupportedBrowserNotification.jsx